import * as z from "zod";

export const InstallTimeseriesPointSchema = z.object({
  /** ISO date `YYYY-MM-DD`, midnight UTC. */
  day: z.iso.date(),
  count: z.number().int().min(0),
});

export type InstallTimeseriesPoint = z.infer<
  typeof InstallTimeseriesPointSchema
>;

export const EarningsSnapshotSchema = z.object({
  /** Cents stringified to preserve BigInt precision over the wire. */
  lifetimeEarnedCents: z.string(),
  availableCents: z.string(),
  pendingCents: z.string(),
  totalInstalls: z.number().int().min(0),
  last7dInstalls: z.number().int().min(0),
  prior7dInstalls: z.number().int().min(0),
  /** Integer percentage. -100 ≤ x; can exceed +100. */
  last7dDeltaPct: z.number().int(),
  /** ISO datetime of the next scheduled payout, or null. */
  nextPayoutDate: z.iso.datetime().nullable(),
  installTimeseries: z.array(InstallTimeseriesPointSchema),
});

export type EarningsSnapshot = z.infer<typeof EarningsSnapshotSchema>;

export const getEarnings = {
  name: "getEarnings" as const,
  input: z.object({}),
  output: EarningsSnapshotSchema,
};
